import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Login from "./components/Login";
import SignUp from "./components/SignUp";
import ForgotPassword from "./components/ForgotPassword";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import TitleScreen from "./components/TitleScreen";
import LoadingScreen from "./components/LoadingScreen";
import HomeScreen from "./components/HomeScreen";
import AdminLogin from "./components/AdminLogin";
import AdminSignUp from "./components/AdminSignUp";
import StationDashboard from "./components/StationDashboard";
import AlertHistory from "./components/AlertHistory";
import UserAlertHistory from "./components/UserAlertHistory";
import WaypointLoading from "./components/WaypointLoading";
import PatrolDashboard from "./components/PatrolDashboard";
import EditProfile from "./components/EditProfile";
import DroneControl from "./components/DroneControl";

import ResetPassword from "./components/ResetPassword";
// Wrapper to use AnimatePresence with Routes
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><TitleScreen /></PageWrapper>} />
        <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />
        <Route path="/signup" element={<PageWrapper><SignUp /></PageWrapper>} />
        <Route path="/forgot-password" element={<PageWrapper><ForgotPassword /></PageWrapper>} />
        <Route path="/terms" element={<PageWrapper><Terms /></PageWrapper>} />
        <Route path="/privacy" element={<PageWrapper><Privacy /></PageWrapper>} />
        <Route path="/loading" element={<PageWrapper><LoadingScreen /></PageWrapper>} />
        <Route path="/home" element={<PageWrapper><HomeScreen  /></PageWrapper>} />
        <Route path="/admin-login" element={<PageWrapper><AdminLogin /></PageWrapper>} />
        <Route path="/admin-signup" element={<PageWrapper><AdminSignUp /></PageWrapper>} />
        <Route path="/station-dashboard" element={<PageWrapper><StationDashboard /></PageWrapper>} />
        <Route path="/alerts-history" element={<PageWrapper><AlertHistory /></PageWrapper>} />
        <Route path="/user-alert-history" element={<PageWrapper><UserAlertHistory /></PageWrapper>} />
        <Route path="/waypoint-loading" element={<PageWrapper><WaypointLoading /></PageWrapper>} />
        <Route path="/patrol-dashboard" element={<PageWrapper><PatrolDashboard /></PageWrapper>} />
        <Route path="/edit-profile" element={<PageWrapper><EditProfile /></PageWrapper>} />
        <Route path="/reset-password" element={<PageWrapper><ResetPassword /></PageWrapper>} />
        <Route path="/drone-control" element={<PageWrapper><DroneControl /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

// Motion wrapper for page transitions
const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, x: 50 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -50 }}
    transition={{ duration: 0.4 }}
    style={{ height: "100%" }}
  >
    {children}
  </motion.div>
);

function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
